export type DropHit = {
  id: string;
  type?: string;
  position?: { x: number; y: number };
  positionAbsolute?: { x: number; y: number };
  width?: number | null;
  height?: number | null;
};

export function resolveDropTargetId(
  hits: ReadonlyArray<DropHit>,
  cursor?: { x: number; y: number },
): string | undefined {
  const nonZone = hits.filter((n) => n.type !== "zone");
  if (nonZone.length === 0) return undefined;
  if (!cursor || nonZone.length === 1) return nonZone[0].id;

  let best: DropHit | undefined;
  let bestDist = Infinity;
  for (const h of nonZone) {
    const pos = h.positionAbsolute ?? h.position;
    if (!pos) {
      if (!best) best = h;
      continue;
    }
    const w = h.width ?? 0;
    const hi = h.height ?? 0;
    const cx = pos.x + w / 2;
    const cy = pos.y + hi / 2;
    const dx = cursor.x - cx;
    const dy = cursor.y - cy;
    const d = dx * dx + dy * dy;
    if (d < bestDist) {
      bestDist = d;
      best = h;
    }
  }
  return best?.id;
}
